import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { UNLOCK_WSPOS } from './actionTypes';
import { unlockWSPositionSuccessful, unlockWSPositionFailed } from './actions';

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const wsposAPI = getWorkstationsAPI();

// Is user register successfull then direct plot user in redux.
function* unlockWSPosition({ payload: { wspos, token , history } }) {
    console.log(wspos, history)
    try {
        console.log(wspos,token)
        const response = yield call(wsposAPI.unlockWSPosition, wspos, token);
        history.go()
        yield put(unlockWSPositionSuccessful(response.message));

    } catch (error) {
        console.log(error)
        yield put(unlockWSPositionFailed(error));
    }
}

export function* watchUnlockWSPosition() {
    yield takeEvery(UNLOCK_WSPOS, unlockWSPosition);
}

function* unlockWSPositionSaga() {
    yield all([fork(watchUnlockWSPosition)]);
}

export default unlockWSPositionSaga;